import { Ornament } from "./Ornament";

export const Footer = () => (
  <footer className="mt-24 bg-[#1F1510] text-[#EADFCB]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="flex justify-center mb-8 text-accent">
        <Ornament className="w-40 h-5" />
      </div>
      <div className="grid gap-10 md:grid-cols-3 text-center md:text-left">
        <div>
          <h4 className="font-[Cinzel] text-lg mb-3 text-accent">Divânu Lugâti't-Türk</h4>
          <p className="text-sm leading-relaxed text-[#C9B99E]">
            Kaşgarlı Mahmud'un 1072-1074 yılları arasında kaleme aldığı, Türk dilinin ilk
            ansiklopedik sözlüğünün ruhundan ilham alan dijital bir okuma deneyimi.
          </p>
        </div>
        <div>
          <h4 className="font-[Cinzel] text-lg mb-3 text-accent">Bölümler</h4>
          <ul className="text-sm space-y-2 text-[#C9B99E]">
            <li>Aranabilir Sözlük</li>
            <li>Kaşgarlı'nın Dairevi Dünya Haritası</li>
            <li>Savlar Koleksiyonu</li>
          </ul>
        </div>
        <div>
          <h4 className="font-[Cinzel] text-lg mb-3 text-accent">Kaynak</h4>
          <p className="text-sm leading-relaxed text-[#C9B99E]">
            Özgün nüsha: Millet Yazma Eser Kütüphanesi, Ali Emiri Koleksiyonu No: 4189.
            İçerikler eğitim amaçlı örnek seçkidir.
          </p>
        </div>
      </div>
      <div className="mt-10 pt-6 border-t border-[#3A2C20] text-center text-xs text-[#9B8A72]">
        <p className="text-[#C9B99E] text-sm mb-1">
          Zeytinburnu Merkezefendi Anadolu İmam Hatip Lisesi · “Dilimizin Zenginlikleri” Projesi
        </p>
        <p className="mb-3">
          Hazırlayanlar: Selma Çalışkan (Türk Dili ve Edebiyatı Öğretmeni) · Metehan Sucu (11. Sınıf Öğrencisi)
        </p>
        © {new Date().getFullYear()} Dijital Codex · Bilig edebi til üze.
      </div>
    </div>
  </footer>
);
